import * as pathToRegexp from 'path-to-regexp';
export function routeToString(route, routesMap) {
    const { name, params } = route;
    const pattern = routesMap[name];
    const toPath = pathToRegexp.compile(pattern);
    const path = toPath(params || {});
    return path;
}
function extractParams({ pattern, path }) {
    if (!path) {
        return {};
    }
    const keys = [];
    const values = pathToRegexp(pattern, keys).exec(path);
    return keys.reduce((acc, { name }, idx) => ({ ...acc, [name]: values && values[idx + 1] }), {});
}
export function stringToRoute(path, routesMap) {
    const routeKeys = Object.keys(routesMap);
    const name = routeKeys.find(key => {
        const pattern = routesMap[key];
        const values = pathToRegexp(pattern).exec(path);
        return !!values;
    });
    if (!name) {
        return null;
    }
    const params = extractParams({ pattern: routesMap[name], path });
    return {
        name,
        params,
    };
}
//# sourceMappingURL=route.js.map